import React, {
  createContext,
  useContext,
} from 'react';

const DropdownContext = createContext({
  open: false,
  toggleOpen: () => {},
});

export const useDropdownContext = () =>
  useContext(DropdownContext);

const DropdownProvider = ({
  value,
  children,
}) => (
  <DropdownContext.Provider value={value}>{children}</DropdownContext.Provider>
);

export default DropdownProvider;
